// extracted by mini-css-extract-plugin
export default {"form_container":"styles_form_container__WbcvV","input":"styles_input__H7wiK","btn":"styles_btn__AxFJC","btn_delete":"styles_btn_delete__RrD9B","btn_edit":"styles_btn_edit__6ChnB"};